/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface DeleteCollectionRequest {
    collection: DeleteCollectionCollectionEnum;
}

export interface DeleteDocumentRequest {
    id: number;
    collection: DeleteDocumentCollectionEnum;
}

export interface IndexCollectionRequest {
    collection: IndexCollectionCollectionEnum;
}

export interface IndexCollectionSubsetRequest {
    collection: IndexCollectionSubsetCollectionEnum;
    requestBody: Array<number>;
}

export interface StatusRequest {
    collection: StatusCollectionEnum;
}

/**
 * 
 */
export class IndexApi extends runtime.BaseAPI {

    /**
     * Creates request options for completeStatus without sending the request
     */
    async completeStatusRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/index/status/all`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async completeStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string; }>> {
        const requestOptions = await this.completeStatusRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async completeStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string; }> {
        const response = await this.completeStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteCollection without sending the request
     */
    async deleteCollectionRequestOpts(requestParameters: DeleteCollectionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling deleteCollection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/index/{collection}`;
        urlPath = urlPath.replace(`{${"collection"}}`, encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteCollectionRaw(requestParameters: DeleteCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteCollectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCollection(requestParameters: DeleteCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCollectionRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteDocument without sending the request
     */
    async deleteDocumentRequestOpts(requestParameters: DeleteDocumentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteDocument().'
            );
        }

        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling deleteDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/index/{id}/{collection}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"collection"}}`, encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteDocumentRaw(requestParameters: DeleteDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteDocumentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDocument(requestParameters: DeleteDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDocumentRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for indexCollection without sending the request
     */
    async indexCollectionRequestOpts(requestParameters: IndexCollectionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling indexCollection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/index/{collection}`;
        urlPath = urlPath.replace(`{${"collection"}}`, encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async indexCollectionRaw(requestParameters: IndexCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.indexCollectionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async indexCollection(requestParameters: IndexCollectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.indexCollectionRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for indexCollectionSubset without sending the request
     */
    async indexCollectionSubsetRequestOpts(requestParameters: IndexCollectionSubsetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling indexCollectionSubset().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling indexCollectionSubset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/index/{collection}/set`;
        urlPath = urlPath.replace(`{${"collection"}}`, encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async indexCollectionSubsetRaw(requestParameters: IndexCollectionSubsetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.indexCollectionSubsetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async indexCollectionSubset(requestParameters: IndexCollectionSubsetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.indexCollectionSubsetRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for reindexAllCollections without sending the request
     */
    async reindexAllCollectionsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/index/reindex`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async reindexAllCollectionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.reindexAllCollectionsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async reindexAllCollections(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.reindexAllCollectionsRaw(initOverrides);
    }

    /**
     * Creates request options for status without sending the request
     */
    async statusRequestOpts(requestParameters: StatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['collection'] == null) {
            throw new runtime.RequiredError(
                'collection',
                'Required parameter "collection" was null or undefined when calling status().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/index/status/{collection}`;
        urlPath = urlPath.replace(`{${"collection"}}`, encodeURIComponent(String(requestParameters['collection'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async statusRaw(requestParameters: StatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.statusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async status(requestParameters: StatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.statusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const DeleteCollectionCollectionEnum = {
    Person: 'Person',
    Organisation: 'Organisation',
    Project: 'Project',
    Work: 'Work',
    Publisher: 'Publisher'
} as const;
export type DeleteCollectionCollectionEnum = typeof DeleteCollectionCollectionEnum[keyof typeof DeleteCollectionCollectionEnum];
/**
 * @export
 */
export const DeleteDocumentCollectionEnum = {
    Person: 'Person',
    Organisation: 'Organisation',
    Project: 'Project',
    Work: 'Work',
    Publisher: 'Publisher'
} as const;
export type DeleteDocumentCollectionEnum = typeof DeleteDocumentCollectionEnum[keyof typeof DeleteDocumentCollectionEnum];
/**
 * @export
 */
export const IndexCollectionCollectionEnum = {
    Person: 'Person',
    Organisation: 'Organisation',
    Project: 'Project',
    Work: 'Work',
    Publisher: 'Publisher'
} as const;
export type IndexCollectionCollectionEnum = typeof IndexCollectionCollectionEnum[keyof typeof IndexCollectionCollectionEnum];
/**
 * @export
 */
export const IndexCollectionSubsetCollectionEnum = {
    Person: 'Person',
    Organisation: 'Organisation',
    Project: 'Project',
    Work: 'Work',
    Publisher: 'Publisher'
} as const;
export type IndexCollectionSubsetCollectionEnum = typeof IndexCollectionSubsetCollectionEnum[keyof typeof IndexCollectionSubsetCollectionEnum];
/**
 * @export
 */
export const StatusCollectionEnum = {
    Person: 'Person',
    Organisation: 'Organisation',
    Project: 'Project',
    Work: 'Work',
    Publisher: 'Publisher'
} as const;
export type StatusCollectionEnum = typeof StatusCollectionEnum[keyof typeof StatusCollectionEnum];
